import withAuth from './../../common/helper/auth-component.js';
import { connect } from 'react-redux';
import React, { useState, useEffect } from 'react';
import { initialFormData, initialErrors, fieldValidation  } from '../../common/helper/form-constants.js';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import LoaderOverlay from './../../common/helper/loader.component.js';
import DashboardService from '../../../services/dashboard-service.js';
import { MESSAGES } from '../../constants/constants.js';

const ConfirmTransaction = () => { 
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({txn_utr_id :'', file:''});
  const [errors, setErrors] = useState({ ...initialErrors });
  const { id, orderCode } = useParams();
  const [imageUrl, setImageUrl] = useState('');
  const navigate = useNavigate();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
  };

  const validateField = (fieldName, value) => {
    const errorMessage = fieldValidation(fieldName, value);
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
    return errorMessage
  };

  const confirmTransaction = (e) => {
    e.preventDefault();
    let hasErrors;
    Object.keys(formData).forEach(fieldName => {
      const error = validateField(fieldName, formData[fieldName]);
      if (error) {
          hasErrors = true;
      }
  });
  if (!imageUrl) {
    toast.error('Please upload image.');
    return;
  }

  if(!hasErrors) {
    setLoading(true);
    formData.file = imageUrl.split(',')[1];
    const formDataToSend = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      formDataToSend.append(key, value);
    });
    formDataToSend.append('file', imageUrl.split(',')[1]);
    DashboardService.confirmTransaction(id,formDataToSend)
    .then(response => {
      toast.success('Transaction confirmed successfully.')
      navigate('/transactions');
      setLoading(false);
    })
    .catch(error => {
      setLoading(false);
      try {
        const errorMessage = error.response.data
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
      } catch (e){
        toast.error( MESSAGES.SERVER_ERROR)
      }
    });
  }

  }
  const handleFileChange  = () => {
    const file = event.target.files[0];
    const maxSize = 2 * 1024 * 1024; // 2 MB

    if (!file.type || !file.type.startsWith('image/')) {
      toast.error('Please select an image file.');
      return;
    }

    if (file && file.size <= maxSize) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageUrl(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setImageUrl('');
      toast.error('File size exceeds 2 MB. Please select a smaller file.');
    }

  }

  useEffect(() => {
    document.body.style.backgroundImage = '';

      document.body.style.backgroundColor = '#f0f6fa';
      return () => {
        document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
      };
  }, []);


    return(
      <><LoaderOverlay />
        <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
        <h4 className="updatename updatename1" style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Confirm Transaction</h4>
        <div className="container" style={{backgroundColor: 'white'}}>
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button className="nav-link active tbbtn" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="true" onclick="myFunctiosn()">Confirm Transaction</button>
            </div>
          </nav>
          <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px', paddingBottom: '15px'}}>
            <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
              <div className="panel panel-default">
                <form onSubmit={confirmTransaction}>
                <div className="panel-body" style={{padding: '0px'}}>
                  <div className="col-md-12" style={{padding: 0}}>
                    <div className="col-md-5" style={{padding: '0px', paddingRight: '30px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">TRANSACTION ID</label>
                        <input type="text" className='form-control'  defaultValue="#242540" id="first_name" name="f_name" value={orderCode} readOnly />
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">UTR NUMBER</label>
                        <input type="text" className={`form-control ${errors.txn_utr_id ? 'is-invalid' : ''}`}    placeholder="UTR Number" id="first_name" name="txn_utr_id" onChange={handleChange}/>
                        {errors.txn_utr_id && <div className="invalid-feedback">{errors.txn_utr_id}</div>}
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">ATTACH PAYMENT RECEIPT</label>
                        <input style={{width: '85%', display: 'inline'}} onChange={handleFileChange} type="file" className="form-control" accept="image/*" id="imageInput" name="f_name" />
                        {imageUrl ? (
                        <img src={imageUrl} alt="no image" className="image-preview vjk"  />
                      ) : (
                        <img src="https://www.pngall.com/wp-content/uploads/5/Profile-Male-PNG.png" className="image-preview vjk" />
                      )}
                      </div>
                    </div>
                  </div>
                  <br />
                  <div align="left">
                    <button type="submit" name="btn_admin_details" id="btn_basics_details" className="btn ddfg sebtn whitelabels">Submit</button>
                  </div>
                  <br />
                </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      </>
    )
}

function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(ConfirmTransaction));